/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PraticaConflittoDTO } from './pratica-conflitto-dto';


export interface PraticaCodiceAnprDTO { 
    codice_anpr?: string;
    version?: number;
    conflitti?: Array<PraticaConflittoDTO>;
}

